'use client';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div style={{ padding: 40, fontFamily: 'monospace' }}>
      <h2>Error occured</h2>
      <pre style={{ whiteSpace: 'pre-wrap', color: 'red' }}>
        <pre style={{ whiteSpace: 'pre-wrap', color: 'red' }}>
          {error.stack ?? error.message}
        </pre>
      </pre>
      {error.digest && <p style={{ color: '#888' }}>Digest: {error.digest}</p>}
      <button
        onClick={() => reset()}
        style={{
          marginTop: 16,
          padding: '8px 16px',
          cursor: 'pointer',
        }}
      >
        Try again
      </button>
    </div>
  );
}
